import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";

function AdminDiscountDashboardPage(props) {
    return (
        <AdminLayout backTo={URLS.admin.dashboard} pageTitle={'داشبورد کد‌های تخفیف'}>
            داشبورد کد تخفیف
        </AdminLayout>
    );
}

export default AdminDiscountDashboardPage;